import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

import { AdminIcon, type AdminIconName } from '../icons/AdminIcon';
import { ADMIN_TYPE } from '../../constants/theme';
import type { NavSectionProps } from '../../types';

export const NavRow: React.FC<{ icon: AdminIconName; label: string; open: boolean; selected?: boolean }> = ({ icon, label, open, selected }) => (
  <Box sx={{
    display: 'flex', alignItems: 'center', gap: '10px',
    height: open ? 32 : 30, px: open ? '10px' : 0, justifyContent: open ? 'flex-start' : 'center',
    borderRadius: '8px',
    bgcolor: selected ? 'action.selected' : 'transparent',
    color: selected ? 'text.primary' : 'text.secondary',
    transition: 'background-color .12s ease, color .12s ease',
    '&:hover': { bgcolor: selected ? 'action.selected' : 'action.hover', color: 'text.primary' },
  }}>
    <Box sx={{ display: 'flex', color: selected ? 'primary.main' : 'inherit' }}><AdminIcon name={icon} size={18} /></Box>
    {open && <Box component="span" sx={{ ...ADMIN_TYPE.nav, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</Box>}
  </Box>
);

export const NavSection: React.FC<NavSectionProps> = ({ items, sidebarOpen, onItemClick }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
      {items.map((item) => {
        const label = t(item.labelKey);
        return (
          <Tooltip key={item.to} title={sidebarOpen ? '' : label} placement="right">
            <NavLink to={item.to} end={item.to === '/admin'} style={{ textDecoration: 'none' }} onClick={onItemClick}>
              {({ isActive }) => <NavRow icon={item.icon} label={label} open={sidebarOpen} selected={isActive} />}
            </NavLink>
          </Tooltip>
        );
      })}
    </Box>
  );
};
